import { getWindow } from "@faire/web--source/common/globals/getWindow";

import { PerformanceEvent, getKeyForEvent } from "./PerformanceEvent";

export function trackPerformanceBreakdown(event: PerformanceEvent) {
  const key = getKeyForEvent(event);
  getWindow()?.performance?.mark?.(key);
}
